<template>
    <div>
        <div class="container">
            <e-search
                    :count="count"
                    :data="listQuery"
                    :field-list="fieldList"
                    :list-type-info="listTypeInfo"
                    @handleFilter="handleFilter"
                    @handleReset="handleReset"
            ></e-search>
        </div>
        <div class="order-tips">
            <p><span>提示：</span>
                本系统支持产业链全流程追溯功能。用户可通过石化商城订单关联相关原材料信息，实现与易派客平台的原材料采购订单、库存订单及手工录入成品库存等数据的联动查询。</p>
        </div>
        <div class="container">
            <div class="handle-wrapper flex-sb">
                <div>
                    <eui-btn @click="handleTime">下单时间</eui-btn>
                    <eui-icon icon="eicon-r-l-zhishijiantouzhuangtaishangjiantou"
                              :class="{ 'my-icon': isDown }"></eui-icon>
                </div>
                <eui-btn @click="petroMallOrderExport">导出</eui-btn>
            </div>
            <tableList
                    rowKey="id"
                    :loading="false"
                    :index-show="indexShow"
                    :table-data="tableData"
                    :table-label="tableLabel">
                <!--原材料订单-->
                <template #petroMallOrderOrderList="{ scope: { row } }">
                    <template v-if="row.orderNoStockNoArr.length === 1">
                        <eui-btn type="link" font-size="12px" @click="goToDetail(row)">
                            {{ dealNo(row.orderNoStockNoArr) }}
                        </eui-btn>
                    </template>
                    <template v-if="row.orderNoStockNoArr.length > 1">
                        <eui-btn type="link" font-size="12px" @click="goToDetail(row)">
                            {{ dealNo(row.orderNoStockNoArr) }}
                        </eui-btn>
                        <eui-btn v-if="row.orderNoStockNoArr && row.orderNoStockNoArr.length > 1"
                                 type="link" font-size="12px"
                                 @click="openDialog(row)">
                            查看更多
                        </eui-btn>
                    </template>
                </template>
                <!--备注-->
                <template #remark="{ scope: { row, $index } }">
                    <el-tooltip class="item" effect="dark" placement="top-start" :disabled="!row.remark">
                        <div slot="content">
                            {{ row.remark }}
                        </div>
                        <div class="remark-content" :class="{ 'remark-color': row.remark }"
                             @click="openRemark(row, $index)">
                            {{ row.remark ? row.remark : '支持填写企业内部编号' }}
                        </div>
                    </el-tooltip>
                </template>
                <template #available="{ scope: { row, $index } }">
                    <div>
                        <span v-if="row.available === 1">是</span>
                        <eui-btn v-if="row.available === 1" class="margin-l10" type="link" font-size="12px"
                                 @click="viewAvailable(row.id)">
                            查看详情
                        </eui-btn>
                    </div>
                </template>
                <template #operate="{ scope: { row } }">
                    <eui-btn type="link" font-size="12px" @click.native.prevent="openDrawer(row)">关联原材料订单</eui-btn>
                    <eui-btn type="link" font-size="12px" @click.native.prevent="viewDetail(row)">查看详情</eui-btn>
                    <eui-btn type="link" font-size="12px" @click.native.prevent="viewRawMaterialDetail(row)">查看原材料详情
                    </eui-btn>
                </template>
            </tableList>
            <div class="pagination flex-end">
                <el-pagination
                        background
                        :page-sizes="[10, 20,50,100,200]"
                        layout="total, sizes, prev, pager, next, jumper"
                        :current-page="queryData.pageNum"
                        :page-size="queryData.pageSize"
                        :total="queryData.pageTotal"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"/>
            </div>
        </div>
        <EDialog
                dialog-title="备注"
                :center-dialog-visible.sync="remarkVisible"
                popup-width="520px"
                :close-model="false"
                @resetPopupData="onCancel"
                @submitPopupData="onSubmit"
        >
            <div class="order-tips margin-b10">
                <p><span>提示：</span>
                    支持企业内部单号，用于石化商城订单与企业内部单号关联，例如填写企业生产令号、ERP单号等。
                </p>
            </div>
            <div class="flex">
                <div style="width: 50px;">备注：</div>
                <el-input
                        v-model="dialogRemark"
                        type="textarea"
                        placeholder="请输入备注信息"
                        :maxlength="300"
                        show-word-limit
                ></el-input>
            </div>

        </EDialog>
        <!-- 现货查看详情-->
        <available-dialog
                v-if="availableVisible"
                :availableVisible.sync="availableVisible"
                :petroMallOrderId="petroMallOrderId"
        />
        <!--操作：查看详情-->
        <order-detail-dialog
                v-if="viewDetailVisible"
                :viewDetailVisible.sync="viewDetailVisible"
                :petroMallOrderId="petroMallOrderId"
        />
        <!--原材料订单查看更多-->
        <OrderDialog :visible.sync="dialogVisible" :petroMallOrderOrderList="petroMallOrderOrderList"/>
        <!--关联原材料订单-->
        <OrderDrawer
                v-if="drawerVisible"
                :visible.sync="drawerVisible"
                :petroMallOrderId="petroMallOrderId"
                :availableParent="available"
                @refresh="petroMallOrderPage"/>
    </div>
</template>

<script>
import eSearch from '@/modules/projectA/components/common/e-search';
import tableList from '@/modules/projectA/components/common/e-table-list.vue';
import {listTypeInfo, fieldList, tableLabel, listQuery, getPetroMallOrderOrderList} from '../common/mallOrder';
import {epecMallUrl} from '@/modules/projectA/api/config';
import availableDialog from './components/availableDialog';
import api from '@/modules/projectA/api/order';
import utils from '@/modules/projectA/utils/utils';
import orderDetailDialog from './components/orderDetailDialog';
import OrderDialog from './components/OrderDialog';
import EDialog from '@/modules/projectA/components/common/e-dialog.vue';
import OrderDrawer from './components/OrderDrawer.vue';

export default {
  name: "index",
  components: {
    eSearch,
    tableList,
    availableDialog,
    orderDetailDialog,
    EDialog,
    OrderDialog,
    OrderDrawer
  },
  data() {
    return {
      dialogRemark: '',
      index: 0,
      remarkVisible: false,
      drawerVisible: false,
      dialogVisible: false,
      available: '',
      petroMallOrderId: 0,
      viewDetailVisible: false,
      isDown: false,
      count: 10,
      listQuery,
      listTypeInfo,
      fieldList,
      tableLabel,
      checked: false,
      indexShow: true,
      tableData: [],
      petroMallOrderOrderList: [],
      queryData: {
        pageNum: 1,
        pageSize: 10,
        pageTotal: 0,
      },
      availableVisible: false,
    }
  },
  methods: {
    onCancel() {
      this.remarkVisible = false;
      this.dialogRemark = '';
    },
    async onSubmit() {
      const {index, dialogRemark: remark, id} = this;
      const res = await api.petroMallOrderModify({petroMallOrderId: this.petroMallOrderId, remark});
      if (res.code === '200') {
        this.$message.success('备注成功');
        this.$set(this.tableData[index], 'remark', remark);
        this.onCancel();
      }
    },
    openRemark(row, index) {
      this.remarkVisible = true;
      this.index = index;
      const {remark = '', id} = row;
      this.dialogRemark = remark;
      this.petroMallOrderId = id;
    },
    //关联原材料订单
    openDrawer(row) {
      const {id, available} = row;
      this.petroMallOrderId = id;
      this.drawerVisible = true;
      this.available = String(available);
    },
    //查看原材料详情
    viewRawMaterialDetail(row) {
      const {id} = row;
      this.$router.push({name: 'rawMaterialDetail', query: {petroMallOrderId: id, type: '2', id}});
    },
    viewDetail(row) {
      this.petroMallOrderId = row.id;
      this.viewDetailVisible = true;
    },
    handleTime() {
      ('1:升序；2：降序');
      this.queryData.orderBySubmitTime = this.queryData.orderBySubmitTime === 1 ? 2 : 1;
      this.isDown = !this.isDown;
      this.queryData.pageNum = 1;
      this.petroMallOrderPage();
    },
    async petroMallOrderExport() {
      const res = await api.petroMallOrderExport(this.listQuery);
      if (res.type == 'application/json') {
        utils.fileExportResponseError(res);
      } else {
        let time = utils.formatDate(new Date(), 'yyyyMMdd');
        utils.downFile(res, '石化商城订单_' + time);
      }
    },
    viewAvailable(id) {
      this.availableVisible = true;
      this.petroMallOrderId = id;
    },
    getPetroMallOrderOrderList,
    openDialog(row) {
      this.petroMallOrderOrderList = row.orderNoStockNoArr;
      console.log(this.petroMallOrderOrderList, 'this.petroMallOrderOrderList')
      this.dialogVisible = true;
    },
    dealNo(val) {
      if (val && val.length > 0) {
        return val[0].stockNo ? val[0].stockNo : val[0].orderNo;
      }
      return '';
    },
    goToDetail(row) {
      const {stockId, orderId} = row.orderNoStockNoArr[0];
      if (orderId) {
        window.open(
          `${epecMallUrl}/materialPurchasingOrder?orderId=${orderId}&orderFlag=orderDetail&flag=canHandle`,
          '_blank'
        );
      } else {
        this.$router.push({
          name: 'StockDetail',
          params: {
            id: stockId,
          },
        });
      }
    },
    handleCurrentChange(val) {
      this.queryData.pageNum = val;
      this.petroMallOrderPage();
    },
    handleSizeChange(val) {
      this.queryData.pageNum = 1;
      this.queryData.pageSize = val;
      this.petroMallOrderPage();
    },
    handleFilter(val) {
      this.queryData = {...this.queryData, ...val, pageNum: 1};
      const {submitTime, arriveTime} = val;
      if (submitTime && submitTime.length > 0) {
        this.queryData.submitTimeBegin = submitTime[0];
        this.queryData.submitTimeEnd = submitTime[1];
      } else {
        this.queryData.submitTimeBegin = null;
        this.queryData.submitTimeEnd = null;
      }
      if (arriveTime && arriveTime.length > 0) {
        this.queryData.arriveTimeBegin = arriveTime[0];
        this.queryData.arriveTimeEnd = arriveTime[1];
      } else {
        this.queryData.arriveTimeBegin = null;
        this.queryData.arriveTimeEnd = null;
      }

      this.petroMallOrderPage();
    },
    handleReset() {
      this.queryData = {
        pageNum: 1,
        pageSize: 10,
        pageTotal: 0,
      }
      this.petroMallOrderPage();
    },
    async petroMallOrderPage() {
      let res = await api.petroMallOrderPage(this.queryData);
      if (res.code === '200') {
        const {records, total} = res.data;
        this.tableData = records || [];
        this.queryData.pageTotal = total || 0;

        //处理原材料订单 整合两个数组返回数据
        this.tableData.forEach(item => {
          const {petroMallOrderOrderList = [], petroMallOrderStockList = []} = item;
          const orderNoStockNoArr = petroMallOrderOrderList.concat(petroMallOrderStockList)
          this.$set(item, 'orderNoStockNoArr', orderNoStockNoArr || []);
        })
      }
    },
  },
  mounted() {
    this.petroMallOrderPage();
  }
}
</script>

<style scoped lang="scss">
.my-icon {
    transform: rotate(180deg);
}
.order-tips {
    padding: 15px 10px;
    background: #e8efff;
    margin-bottom: 10px;
    span {
        color: #f0250f;
    }
}

.remark-content {
    height: 28px;
    line-height: 28px;
    color: rgb(220, 223, 230);
    border: 1px solid rgb(220, 223, 230);
    border-radius: 4px;
    padding: 0 6px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.remark-content.remark-color {
    color: #333;
}
</style>